import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches the appointment types valid for a patient. */
export function useListPatientAppointmentTypes(patientId: string | undefined) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['patient-appointment-types', patientId],
    enabled: !!patientId,
    queryFn: async () => {
      const response = await api.get('/patients/:patientId/appointment-types', {
        params: { patientId: patientId! },
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
  })
}
